
export const BannerData = {

  // videoUrl:"https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/NEWSELTOS%2FBannerimg%2Fseltos_6s_d.mp4?alt=media&token=0d83735b-2737-4728-9dff-cc293b020c4b",
  mobileImageUrl:"https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fallnewseltos.jpeg?alt=media&token=004e7429-24ae-4814-a585-962a1a845aab",
  imageUrl:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fallnewseltos.jpeg?alt=media&token=004e7429-24ae-4814-a585-962a1a845aab",
  title: "The all-new Seltos",
  subtitle: "Badass. Forever.",
  price: "₹10 99 000#",

  features: [
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fnewseltos2Flogo_1_2.webp?alt=media&token=58311e6d-eff9-4c86-a20c-670b8a7f8cfc",
      text: "ADAS Level 2 with 21 Autonomous Features",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fnewseltos2Flogo_2_1.webp?alt=media&token=9c8f73b6-fbd4-4017-b6d4-71e349ba6580",
      text: "Dual Pane Panoramic Sunroof",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fnewseltos2Flogo_3_1.webp?alt=media&token=536a5f61-fd0c-46ae-b969-37ec9e8d3c13",
      text: "Command-Centric Trinity Panoramic Display",
    },
  ],
};


export const carouselData = [
  {
    id: 1,
    title: "5-star safety, BNCAP certified.",
    description:
      "The all-new Kia Seltos isn’t just badass on the outside, it’s badass at its core. Backed by a 5-star BNCAP safety rating, it is made to protect you, no matter what comes your way.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2F5-star%20safety.jpeg?alt=media&token=18642b58-3fa0-46d6-b304-c01a1ed0a03f",
  },
  {
    id: 2,
    title: "Dominating driving experience.",
    description:
      "ADAS Level 2* with 21 Autonomous Features puts cutting-edge technology within reach. Every manoeuvre feels effortless, giving you confidence on every journey.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fdomasticdriving.webp?alt=media&token=3343822c-721f-4f43-a422-d8a4d267eae5",
  },
  {
    id: 3,
    title: "Enhanced built and space.",
    description:
      "With optimised dimensions, best-in-segment length of 4,460 mm (+95 mm), higher ground clearance, and expanded interior space, the all-new Seltos is designed for your comfort and practicality on every drive.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fsection_3.webp?alt=media&token=25b549aa-794a-4620-8a4e-0562d4b93ea7",
  },
  {
    id: 4,
    title: "Safety crafted from armored steel.",
    description:
      "The all-new Seltos is designed to protect what matters most, the high-strength armored steel structure with 27 hot-formed plates & 24 standard safety features ensures maximum rigidity and crash safety, giving you confidence in every drive.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fsection_4.webp?alt=media&token=c6cda63c-00c8-4abb-9f9c-cb248cc8f1c3",
  },
];





export const CircleData = [

  {
    title: " Frost Blue",
    color: "#5d9aa6",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2F08-d.webp?alt=media&token=50ba82bf-8e68-4eba-b34a-69dcc8e2e49a",
  },
  {
    title: "Aurora Black Pearl",
    color: "#151617",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FAurora%20Black%20Pearl.webp?alt=media&token=31e57eaf-2816-4135-bb5e-817111123139",
  },
  {
    title: "Gravity Grey",
    color: "#444444",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FGravity%20Gray.webp?alt=media&token=168d392c-1d56-4b51-a1e0-d75aea8304c6",
  },

  {
    title: "Morning Haze",
    color: "#E0E8EF",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FMorning%20Haze.webp?alt=media&token=6e921f04-1c33-45db-b250-d0e72947943d",
  },

  {
    title: "Pewter Olive",
    color: "#3e493b",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FPewter%20Olive.webp?alt=media&token=b5f2ec67-695b-491f-959a-ae775ef9647b",
  },

  {
    title: " Ivory Silver Gloss",
    color: "#D7D7D8",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FIvory%20Silver%20Gloss.webp?alt=media&token=5378a45d-f004-4cf1-a06e-7c3a10a3eff0",
  },
  {
    title: "Imperial Blue",
    color: "#2b2c71",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FImperial%20Blue.webp?alt=media&token=dd276e13-1d41-4bd3-9ab2-3f218d82ccdc",
  },

  {
    title: "Glacier White Pearl",
    color: "#f4f9fb",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FGlacier%20White%20Pearl.webp?alt=media&token=73594cf4-6cc6-4e8f-9eea-1ef5d9f71bc2",
  },
  {
    title: " Magma Red",
    color: "#A12424",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FMagma%20Red.webp?alt=media&token=25190565-2594-47de-a20c-b92f4b67c407",
  },



];





export const DetailInfo = [
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Book Kia Seltos Today ",
    desc: "It’s time to own the Badass.",
    link: "",
  },
  {
    bgColor: "#05141f",
    color: "#FFF",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/download.png?alt=media&token=9de03b22-8ba2-433e-9ff0-a78165faaf3a",
    title: "Download Brochure",
    desc: "Get all what you want to know about the Badass Reborn.",
    link: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/NEWSELTOS%2Fbrochure%2FNew_seltos_brochure_desk.pdf?alt=media&token=90d10b66-c810-41ca-8645-f7b31219985d",
  },
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Call us for more information",
    desc: "We'll be happy to answer all your queries. 0000000000",
    link: "tel:+919237386213",
  },
];

export const TrimData = [
  {
    title: "HTE",
    cost: "10,99,000",
    feature1: "Ice Cube MFR LED Headlamps ",
    feature2: "Kia Digital Tiger Face Grille",
    feature3: "Streamline Door Handles (Manual Type)",
    feature4: "Star Map LED Tail Lamps",
    feature5: "Cruise Control with Manual Speed Limit Assist",
    feature6: "Day  Rear View Mirror ",
  },
  {
    title: "HTE(O)",
    cost: "12,09,000",
    feature1: "60:40 Split Rear Seats with Rear Centre Armrest with Cup Holders ",
    feature2: "Star Map LED Connected Tail Lamps",
    feature3: "Electric Parking Brake with Auto Hold (Automatic Only)",
    feature4: "Traction Control Mode [Sand/ Mud/ Snow] (Automatic Only)",
    feature5:
      "Drive Mode Select [Eco/ Normal/ Sport] ",
    feature6: "Paddle Shifters (Automatic Only) ",
  },
  {
    title: "HTK",
    cost: "13,09,000",
    feature1: "Star Map LED Connected Tail Lamps ",
    feature2: "Electric Adjust Outside Mirrors with Auto Fold ",
    feature3: "Rear Defogger",
    feature4: "Streamline Door Handles (Automatic) ",
    feature5: "Smart Key with Push Button Start  Sensor",
    feature6: "Smart Key Proximity Unlock Function ",

  },
  {
    title: "HTK (O)",
    cost: "14,19,000",
    feature1: "Star Map LED Connected Tail Lamps ",
    feature2: "Electric Adjust Outside Mirrors with Auto Fold",
    feature3: "Dual Pane Panoramic Sunroof",
    feature4: "Dual Tone Leatherette Wrapped Steering Wheel",
    feature5: "Smartphone Wireless Charger",
    feature6: "Front Ventilated Seats (Automatic only) ",

  },

  {
    title: "HTX",
    cost: "15,59,000",
    feature1: "64 Color Ambient Mood Lighting ",
    feature2: "12.7cm (5”) Touch Screen - Dual Zone Automatic Temperature Control",
    feature3: "Kia Connect 2.0",
    feature4: "OTA Software Updates with Kia Remote Diagnostics",
    feature5: "Front Ventilated Seats ",
    feature6:
      "Bose Premium Sound System with 8 Speakers ",

  },
  {
    title: "HTX(A)",
    cost: "16,69,000",
    feature1: "31.24cm (12.3”) HD Display Instrument Cluster  ",
    feature2: "Side Parking Sensors (2/Side)",
    feature3: "OTA Software Updates with Kia Remote Diagnostics",
    feature4: "ADAS Level 2 with 21 Autonomous Features",
    feature5: "360 Degree Camera ",
    feature6:
      "Blind View Monitor in Cluster ",

  },

  {
    title: "GTX",
    cost: "18,39,000",
    feature1: "Ice Cube LED Projection Headlamps with Dynamic Welcome Function",
    feature2: "Star Map LED DRLs with Integrated Turn Signal ",
    feature3:
      "Digital Tiger Face with Dark Gunmetal Accents",
    feature4: "R18- 46.20 cm (18”) Sporty Crystal Cut Alloy Wheels",
    feature5: "10-Way Power Driver Seat with Power Lumbar Adjust ",
    feature6: "Integrated Memory System (Driver Seat ) ",

  },
  {
    title: "GTX(A)",
    cost: "19,49,000",
    feature1: "31.24cm (12.3”) HD Display Instrument Cluster ",
    feature2: "OTA Software Updates with Kia Remote Diagnostics",
    feature3:
      "ADAS Level 2 with 21 Autonomous Features",
    feature4: "360 Degree Camera",
    feature5: "Integrated Memory System (Driver Seat )  ",
    feature6: "Blind View Monitor in Cluster",

  },
  {
    title: "X LINE",
    cost: "18,39,000",
    feature1: "Ice Cube LED Projection Headlamps with Dynamic Welcome Function",
    feature2: "Star Map LED DRLs with Integrated Turn Signal",
    feature3: "Digital Tiger Face with Dark Gunmetal Accents",
    feature4: "10-Way Power Driver Seat with Power Lumbar Adjust ",
    feature5: "Xclusive Matte Graphite  Black Pearl as exterior color options",
    feature6: "R18- 46.20 cm (18”) Black painted Alloy Wheels",

  },
  {
    title: "X LINE(A)",
    cost: "19,49,000",
    feature1: "31.24cm (12.3”) HD Display Instrument Cluster ",
    feature2: "OTA Software Updates with Kia Remote Diagnostics ",
    feature3: "ADAS Level 2 with 21 Autonomous Features",
    feature4: "360 Degree Camera",
    feature5: "Xclusive Matte Graphite  Black Pearl as exterior color options",
    feature6: "Blind View Monitor in Cluster",

  },
];


export const CarouselData1 = [
  {
    sub: "EXTERIOR",
    title: "The bold look of Badass.",
    data: "Step into the all-new Seltos, where style meets attitude. With its aggressive, muscular build, striking shoulder lines, and fierce front and rear, it’s built to stand out.",
    carData: [
      {
        title: "Digital Tiger Grill &amp; Hood Integration",
        description:
          "The signature Digital Tiger Face, with iconic Tiger Nose, seamlessly integrates into the hood. With a bold hood scoop, it enhances the SUV’s rugged, commanding presence​.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FExterior_1.webp?alt=media&token=912e7175-275c-4fac-9ff1-7a409d5c67a3",
      },
      {
        title: "Intense Ice Cube LED Projection Headlamps with Star Map LED DRLs",
        description:
          "Look as badass as you feel with constellation-inspired Star Map LED DRLs with integrated turn signals &amp; Ice Cube LED Projection Headlamp to add a bold finish to the high-tech front design.​​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FExterior_2.webp?alt=media&token=0679ae31-d47e-44e7-8632-0a9132bba06c",
      },
      {
        title: "Bigger space with increased dimensions",
        description:
          "With enhanced dimensions, best-in-segment length of 4,460 mm (+95 mm), higher ground clearance, and expanded interior space, the all-new Seltos is designed for your comfort and practicality on every drive.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fexter_3.webp?alt=media&token=84f8306a-d16d-4dc4-ba19-293b83dbb8ee",
      },
      {
        title: "Automatic Streamline Door Handles",
        description:
          "Step into the future with segment-first* flush-type door handles&nbsp;for effortless unlocking. Auto-flush handles ensure a seamless entry every time.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FExterior_4.webp?alt=media&token=a00f00a0-908a-4efa-8938-e41ab8f688c8",
      },

      {
        title: "Iconic R18- 46.20 cm (18”) Sporty Crystal Cut Alloy Wheels &amp; Neon Brake callipers​",
        description: "The 18” Crystal Cut alloy wheels with all-disc brakes make a bold statement, while the GT-Line’s neon callipers upgrade the style and performance to a whole new level.​.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FExterior_5.webp?alt=media&token=5e2bf22e-836a-44a6-b6d6-d91d014568e7",
      },
      {
        title: "Striking Star Map LED connected Tail Lamps",
        description: "Signature Star Map LED connected Tail Lamps light up the rear profile, adding a bold, futuristic touch that’s impossible to ignore.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2FExterior_6.webp?alt=media&token=aeb4d6c7-5c28-4a69-8e2a-fd007009736c",
      },

    ],
  },



]








export const CarouselData2 = [
  {
    sub: "INTERIOR",
    title: "Badass to the core. Inside & out.",
    data: "The all-new Seltos turns every drive into an experience full of confidence and comfort. With its futuristic Trinity Panoramic Display, Dual-Tone Interiors & Rear AC Vents, it makes every long distance seem short.",
    carData: [
      {
        title: "Dual Pane Panoramic Sunroof",
        description:
          "The all-new Seltos features a panoramic sunroof that elevates the interior, offering passengers a sense of openness and luxury.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fint_mb_1.mp4?alt=media&token=86140693-63c9-4988-accf-e3b39b1ff29a",
      },
      {
        title: "64 Color Cabin Surround Ambient Lighting",
        description: "Turn your space into a vibe with ambient lighting on the door trims and full crash pad, offering a range of colours to match whatever mood you’re in.​ ",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fint_mb_2.mp4?alt=media&token=7292e329-1abd-4466-804f-9344a945182a",
      },
      {
        title: "Command-Centric Trinity Panoramic Display",
        description: "The all-new Seltos redefines the game with the Command-Centric Trinity Panoramic Display, blending seamless tech for a smooth and smart driving experience.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fint_mb_3.webp?alt=media&token=7b2de470-7468-478e-bc8d-8bf97be30b89",
      },
      {
        title: "Bose Premium Sound System with 8 Speakers",
        description:
          "The premium Bose Sound System delivers crystal-clear audio, enriching every note and enhancing both your music &amp; overall driving experience.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fint_desk_4.webp?alt=media&token=56940a8b-ee97-4393-9c91-38374cf68b38",
      },

      {
        title: "Double D-Cut Dual Tone Leatherette Wrapped Steering Wheel",
        description:
          "The Sporty Double D-Cut dual-tone leatherette steering wheel offers seamless access to audio, cruise control, and drive modes, all with effortless precision.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fint_desk_5.webp?alt=media&token=f073a30c-7376-4978-82af-909128fd960d",
      },
      {
        title: "Dual-Tone Leatherette Seats",
        description:
          "Experience stylish, comfortable, and durable seating with a sophisticated dual-tone finish, enhancing every drive with premium refinement.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fint_desk_6.webp?alt=media&token=0b657e3d-7c56-4ccf-81b6-e5255fb39167",
      },

    ],
  },
]








export const CarouselData3 = [
  {
    sub: "PERFORMANCE",
    title: "Ultimate power meets game changing confidence.",
    data: "The all-new Seltos delivers a thrilling drive with powerful, fuel-efficient engines. With three drive modes and paddle shifters, it gives you the freedom to own the road, your way.​",
    carData: [
      {
        title: "Smartstream G1.5 Petrol Engine",
        description:
          "With 84.4 kW and 143.8 Nm at your command, experience maximum performance on every Badass drive.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fper_1.webp?alt=media&token=9fa0778c-9f66-425e-9549-fd2d96278583",
      },
      {
        title: "Smartstream G1.5 T-GDi Petrol Engine",
        description:
          "Experience reliable, strong, and efficiently engineered performance with 117.5 kW and 253 Nm, redefining every journey with smooth power and superior refinement.​​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fper_2.webp?alt=media&token=6f3e76ff-e359-4a41-bd16-19a890e3fc04",
      },
      {
        title: "1.5l CRDi VGT Diesel Engine",
        description:
          "Crafted for strength and fuel efficiency, it produces 85 kW and 250 Nm, offering smooth driving dynamics and superior responsiveness on every journey.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fper_3.webp?alt=media&token=5dff4af4-53b8-4e09-aef3-a9af0fda0de3",
      },


    ],
  },



]







export const CarouselData4 = [
  {
    sub: "SAFETY",
    title: "Crafted for your peace of mind.",
    data: "The all-new Seltos doesn’t just take you places, it ensures you’re always safe, letting you drive with the peace of mind that comes from knowing you're protected, no matter the road ahead.",
    carData: [
      {
        title: "6 Airbags as Standard",
        description:
          "Equipped with six strategically placed airbags, the all-new Seltos puts safety at the forefront of every journey.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fsafety_desk_1.webp?alt=media&token=6b56de13-ff4c-4bde-90f7-c7006ec7cbe2",
      },
      {
        title: "Precise All-Wheel Disc Brakes",
        description: "Experience precision at your command with All-Wheel Disc Brakes, where you're not just driving a vehicle, you're mastering the road.​ ",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fsafety_desk_2.webp?alt=media&token=7d11dad4-30c3-43b1-b9b5-18683f3dd209",
      },
      {
        title: "Rear Side Parking Sensor",
        description: "Navigate tight spots with confidence, as rear side parking sensors alert you to obstacles and ensure flawless parking every time.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fsafety_desk_3.webp?alt=media&token=c10adcb0-e75f-437c-86d3-23c742e77077",
      },
      {
        title: "Surround 360° Camera and Guided Rear View Camera",
        description:
          "Own every turn with the 360° camera for flawless parking and Guided Rear View Camera to keep your blind spots in check.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fsafety_desk_4.webp?alt=media&token=218f535d-8713-4348-b0ae-0a16874fb265",
      },

      {
        title: "Advanced K3 platform",
        description:
          "Drive with confidence on the K3 platform, engineered for enhanced stability, safety, and a smoother, more dynamic performance every time you hit the road.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fsafety_desk_5.webp?alt=media&token=de8e140d-c516-4feb-8bba-df61c1906b1f",
      },


    ],
  },
]






export const CarouselData5 = [
  {
    sub: "ADAS",
    title: "Safety maximised with intelligent ADAS Level 2*.",
    data: "The all-new Seltos, equipped with ADAS Level 2 with 21 Autonomous Safety Features, doesn’t just protect, it anticipates. It gives you the peace of mind to focus on the journey ahead, knowing every turn is backed by smart safety that keeps you one step ahead.",
    carData: [
      {
        title: "Smart Cruise Control (SCC) with Stop & Go",
        description:
          "Smart Cruise Control with Stop and Go empowers you for effortless, stress-free travel on highways and urban streets.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fadas_1.webp?alt=media&token=eee15c7a-c0cb-4751-912c-37d6630bbcf2",
      },
      {
        title: "Front Collision Avoidance Assist (Junction Crossing)",
        description: "Front Collision Warning and Avoidance Assist in the all-new Seltos are your vigilant guardians, working tirelessly to prevent  accidents and ensure your security on every drive.​ ",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fadas_4.mp4?alt=media&token=60933da8-9b3a-4f28-87b0-6b5773d9e3c1",
      },
      {
        title: "Lane Keeping Assist (LKA)",
        description: "Lane Keep Assist is your steadfast companion, ensuring your path remains true. Embrace the confidence of steady, safe journeys in your all-new Seltos.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fadas_5.mp4?alt=media&token=9d8cabd0-8149-47b5-963d-bc5f2d467422",
      },
      {
        title: "Parking Collision Avoidance Assist- Reverse",
        description:
          "Scans your surroundings as you reverse, alerting you to approaching traffic and even applying brakes if needed, for a safer, stress-free drive.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/NEWSELTOS%2FADAS%2Fadas_4.mp4?alt=media&token=28c31a79-3f1d-4b84-bb48-5c47f1b45af7",
      },

      {
        title: "SVM with Blind View Monitor in Cluster",
        description:
          "See everything around you with the surround-view camera, giving you a clear bird’s-eye perspective for effortless parking and stress-free city driving.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/NEWSELTOS%2FADAS%2Fadas_5.mp4?alt=media&token=75dfb4d6-9923-4b02-82ad-cd90eb992f68",
      },


    ],
  },
]




export const CarouselData6 = [
  {
    sub: "CONNECTIVITY",
    title: "Seamless, smart, and always within reach.",
    data: "The all-new Seltos is your personal comfort zone on wheels. With tech like Over-the-air (OTA) Software Updates, Remote Diagnosis, and Multilingual VR Commands, it keeps you effortlessly connected wherever you go.",
    carData: [
      {
        title: "Kia Connect Diagnosis (KCD) &amp; Over-the-Air (OTA) Software Updates",
        description:
          "Monitor your vehicle’s health instantly with remote diagnostics for worry-free drives and keep your all-new Seltos at peak performance with OTA updates for 31 controllers, ensuring it stays smart, advanced, and up-to-date, always.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fconn_1.webp?alt=media&token=7bc3c888-a8db-4ead-bcb4-40084f9fecaa",
      },
      {
        title: "Find my car with surround view monitor",
        description: "Locate your vehicle easily in busy parking areas with a clear overhead view, ensuring convenience and confidence every time you park or return to your all-new Seltos.​ ",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fconn_2.webp?alt=media&token=b7ef3e94-5937-409d-b6e9-ca43faaa4ccb",
      },
      {
        title: "Remote vehicle alerts",
        description: "Stay connected to your all-new Seltos with Geofence Alert, Time Fence Alert, Speed Alert, and Idle Alert, and receive instant notifications if your vehicle enters/exits a restricted area, is driven during restricted hours, exceeds the speed limit, or is idle for too long.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fconn_3.webp?alt=media&token=86d916ac-b76c-4606-b98b-22b5ed385036",
      },



    ],
  },
]










export const CarouselData7 = [
  {
    sub: "COMFORT",
    title: "Redefining comfort with a bold, unapologetic edge.",
    data: "With adjustable seats, cooling vents, and spacious interiors etc., make every journey feel effortless in the all-new Seltos. Whether driving or riding, relaxation is always within reach.",
    carData: [
      {
        title: "Indulgent Ventilated Seats - 1 st Row (Driver &amp; Passenger)",
        description:
          "Whether it’s heating up or cooling down, the all-new Seltos keeps you perfectly comfortable with its 3-Step front ventilated seats.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fcomf_1.mp4?alt=media&token=21eee534-a004-4533-917b-ecbaf5c92e7c",
      },
      {
        title: "Second Row 60:40 Split with Recline Function",
        description: "The 2nd row in all-new Seltos slides, reclines, and splits 60:40, giving you the perfect mix of space and comfort, whatever your mood.​​ ",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fcomf_2%20(1).webp?alt=media&token=ed887fb6-ce74-444f-b93d-b13354633fdf",
      },
      {
        title: "10-Way Power Driver Seat with Power Lumbar Adjust",
        description: "Experience unmatched comfort and personalised support with our 10-way power-adjustable driver seat, designed to adapt perfectly to your posture..​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fcomf_3.webp?alt=media&token=4b996004-5869-4111-a1ff-3d88321e5d6e",
      },
      {
        title: "Centre Console and Armrest",
        description:
          "Rest easy and stay organised with the thoughtfully crafted Centre Console and Armrest.​​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fcomf_4.webp?alt=media&token=3e55436e-a92f-438c-8544-e82a7eadb557",
      },

      {
        title: "FATC Dual Zone Climate Control",
        description:
          "Set your ideal temperature while your co-passengers set theirs for optimal comfort on every journey.​​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fcomf_5.mp4?alt=media&token=fcf83954-d0c0-46de-ab07-f11303dba169",
      },


    ],
  },
]




export const CarouselData8 = [
  {
    sub: "CONVENIENCE",
    title: "Convenience that puts you in complete control.",
    data: "In the all-new Seltos, every drive feels like pure mastery. Experience the thrill of effortless control, where every turn exudes grace, making every moment behind the wheel a grand statement of power.",
    carData: [
      {
        title: "Driver Seat Welcome Retract",
        description:
          "Slide in and out with ease as your seat automatically moves back and returns to your perfect position with the Driver Seat Welcome Retract.​​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fconv_desk_1.mp4?alt=media&token=f7c44090-2be5-4f22-bc6f-0917305ac324",
      },
      {
        title: "Smartphone Wireless Charger",
        description: "Experience fast, reliable, and hassle-free charging, keeping your device powered effortlessly every day.​ ",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fconv_desk_2.avif?alt=media&token=ed416087-d780-4cc3-9d62-57f756e44ae0",
      },
      {
        title: "Paddle Shifters",
        description: "Experience a sporty drive with paddle shifters, allowing for a quick &amp; precise gear change within reach.​​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fconv_desk_3.avif?alt=media&token=687e1c65-c790-4891-92e6-8627189131c3",
      },
      {
        title: "EPB with Auto Hold",
        description:
          "Featuring an Electric Parking Brake with Auto Hold and a Hi-Tech touch, the all-new Seltos enhances convenience and ensures a clutter-free console.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fconv_desk_4.avif?alt=media&token=9546bcbc-057e-45bd-a45f-3a4e989b4264",
      },

      {
        title: "Auto Reverse ORVM",
        description:
          "Adjust ORVM to a lower angle for a better rear-view during reverse with the Auto Reverse ORVM function.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/all-new%20Seltos%2Fconv_desk_5.avif?alt=media&token=4a4c6525-d1d4-4219-910a-2cf91f3f42ca",
      },


    ],
  },
]





export const FaqData = [
  {
    question: "What is the price of the New Kia Seltos Base and Top Model?",
    answer: "The official ex-showroom price of the All-New Kia Seltos base model HTE starts at ₹ 10 99 000* and top model X-Line (A) starts at ₹ 19 49 000*",
  },
  {
    question: "Does new Kia Seltos have sunroof?",
    answer: "Yes, the new Kia Seltos comes with a Dual Pane Panoramic Sunroof, which offers passengers a sense of openness and luxury. The dual-pane panoramic sunroof is available on all Seltos variants starting from the HTK (O).",
  },
  {
    question: "What are the seating options available in the Seltos?",
    answer: "The Kia Seltos is a 5-seater compact SUV that comes with front ventilated seats along with many other features.",
  },
  {
    question: "How many airbags are there in New Kia Seltos?",
    answer: "The all-new Kia Seltos offers 6 airbags and a robust 24-standard-feature safety pack to ensure comprehensive protection for you and your loved ones.",
  },
  {
    question: "What are the engine and transmission options available in the all-new Kia Seltos?",
    answer: "The all-new Kia Seltos offers three engine choices: a Smartstream G1.5 petrol engine with 6 speed manual/IVT transmission, a Smartstream G1.5 T-GDi petrol engine with 6iMT/ 7DCT, and 1.5l CRDi VGT Diesel engine with 6MT/ 6 speed automatic transmission.",
  },
  {
    question: "How many features does the new Kia Seltos offer in its ADAS system?",
    answer: "The Kia Seltos comes with ADAS Level 2+ along with 21 autonomous safety features designed to keep you and your family secure through every mile.",
  },
  {
    question: "Does new Seltos have cruise control?",
    answer: "Yes, new Kia seltos have Smart Cruise Control (SCC) with Stop & Go feature which automatically maintains distance and manages stop-and-go traffic",
  },
  {
    question: "How many colour options are available for the all-new Kia Seltos?",
    answer: "The all-new Kia Seltos is available in 10 Monotone Colours: Morning Haze, Magma Red, Frost Blue, Gravity Gray, Imperial Blue, Glacier White Pearl, Pewter Olive, Ivory Silver Gloss, Aurora Black Pearl(Also available in X-Line) and Xclusive Matte Graphite (X-Line)",
  },
];